import React from "react";

import { Box } from "@mui/material";

import { EducatorsListGrid, RecentlyWorkedEducatorsGrid } from "../components/educators";
import { MainLayout } from "../components/layout/MainLayout";
import { useEducators } from "../hooks/useEducators";
import { useRecentlyWorkedEducators } from "../hooks/useRecentlyWorkedEducators";

export const EducatorsPage: React.FC = () => {
  const { data: educatorsData, isLoading: educatorsLoading, error: educatorsError } = useEducators();
  const {
    data: recentlyWorkedData,
    isLoading: recentlyWorkedLoading,
    error: recentlyWorkedError,
  } = useRecentlyWorkedEducators();

  return (
    <MainLayout>
      <Box sx={{ p: 3 }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <EducatorsListGrid
            data={educatorsData}
            isLoading={educatorsLoading}
            error={educatorsError}
            title="This Week's Educators"
            subtitle="The following team members will be working at your service this week"
          />
          <RecentlyWorkedEducatorsGrid
            data={recentlyWorkedData}
            isLoading={recentlyWorkedLoading}
            error={recentlyWorkedError}
          />
        </Box>
      </Box>
    </MainLayout>
  );
};
